import { streamSSE } from "@/lib/stream-sse";

import type { LabResultsSummaryContext } from "@/types/ai";

import { kyInstance } from "@/api/api-config";

/**
 * Streams AI-generated lab results summary from the backend.
 * Uses Gemini's native structured JSON streaming.
 */
export async function* streamLabResultsSummary(
  context: LabResultsSummaryContext,
  signal?: AbortSignal,
): AsyncGenerator<string, void, unknown> {
  const response = await kyInstance.post("ai/lab/results-summary", {
    json: { context },
    signal,
  });

  for await (const chunk of streamSSE(response, {
    signal,
    errorMessage: "Failed to generate lab results summary",
  })) {
    if (typeof chunk === "string") {
      yield chunk;
    }
  }
}
